var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3B6B94",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6933 27.4206C16.4169 27.4206 16.1405 27.3148 15.9299 27.1042L9.31673 20.4908C8.89442 20.0687 8.89442 19.3863 9.31673 18.9642C9.73884 18.5421 10.4211 18.5421 10.8434 18.9642L16.6933 24.814L29.1567 12.3508C29.5789 11.9287 30.2611 11.9287 30.6834 12.3508C31.1055 12.773 31.1055 13.4553 30.6834 13.8776L17.4568 27.1042C17.3566 27.2046 17.2376 27.2843 17.1066 27.3386C16.9756 27.3928 16.8351 27.4207 16.6933 27.4206Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCheckIcon);
export default __webpack_public_path__ + "static/media/active-check-icon.7cb7eae127ae62e8399495cadf68e3bc.svg";
export { ForwardRef as ReactComponent };